import { SaveButton } from 'src/admin/core'
import { useFormikContext } from 'formik'
import {
  addMinutesToDateTimeUTC,
  formatDateTimeToUTC,
  formatToShortLocalDate,
} from 'src/admin/core/services/dateFunctions'
import { useUpdateProgramRace, useRaceWagers } from '../../hooks'
import { Race, Wager } from '../../models'
import { useAppTranslation, useNotification } from 'src/admin/core/hooks'
import { useContext } from 'react'
import { EventContext, setRaceFormMode } from '../../state'

export const UpdateButton: React.FC<{ afterSave?: (promise: Promise<any>) => void; wagers: Wager[] }> = ({
  afterSave,
  wagers,
}) => {
  const form = useFormikContext()
  const { values, dirty, isValid, setSubmitting } = form
  const { system, label } = useAppTranslation()
  const { updateProgramRace, loading } = useUpdateProgramRace()
  const { errorNotification } = useNotification()
  const {
    dispatch,
    state: { event, race },
  } = useContext(EventContext)

  const handleUpdate = () => {
    setSubmitting(true)
    const raceToSave = values as any

    if (raceToSave.wagerIds.length === 0) {
      form.setFieldError('wagerIds', label('REQUERIDO'))
      return
    }
    if (event.id) {
      raceToSave.programEventId = event.id

      if (Number(raceToSave.raceNumber) > event.numberOfRaces) {
        errorNotification(system('ERROR_NUMERO_CARRERA_MAYOR_A_NUMERO_EVENTO'))
      } else {
        //const wagerIds = Array.isArray(raceToSave.wagerIds) ? raceToSave.wagerIds.split('/') : [raceToSave.wagerIds]

        const response = updateProgramRace({
          variables: {
            input: {
              id: race.id,
              raceNumber: raceToSave.raceNumber,
              typeOfRace: raceToSave.typeOfRace?.code,
              purse: raceToSave.purse,
              distanceId: raceToSave.distanceId?.id,
              wagerIds: getWagersIds(raceToSave.wagerIds),
              runners: raceToSave.runners,
              genderRestriction: raceToSave.genderRestriction,
              ageRestriction: raceToSave.ageRestriction,
              breed: raceToSave.breed,
              course: raceToSave.course,
              postTime: formatDateTimeToUTC(raceToSave.postTime),
              active: raceToSave.active,
            },
          },
        })
        dispatch(setRaceFormMode('CANCEL'))
        afterSave(response)
      }
    } else {
      errorNotification(system('ERROR_EVENTO_NO_ENCONTRADO'))
    }
  }

  const getWagersIds = (value: string | string[]): string[] => {
    if (value.length > 0 && wagers.length > 0) {
      const values: string[] = Array.isArray(value) ? value : value.split('/')
      const ids: string[] = []
      if (wagers.length > 0 && values.length > 0) {
        values.forEach((val: string) => {
          const bet = wagers.find((item: Wager) => item.name.trim() === val.trim())
          if (bet !== undefined) {
            ids.push(bet.id)
          }
        })
      }
      return ids
    }

    return []
  }

  return <SaveButton onClick={handleUpdate} isLoading={loading} disabled={!(dirty && isValid)} />
}
